import { createContext, useContext, useState, useEffect, ReactNode } from "react";
import { setWarmingStateCallback } from "@/lib/api";

interface WarmingContextType {
  isWarming: boolean;
  setIsWarming: (isWarming: boolean) => void;
}

const WarmingContext = createContext<WarmingContextType | undefined>(undefined);

export function WarmingProvider({ children }: { children: ReactNode }) {
  const [isWarming, setIsWarming] = useState(false);

  // Register the callback with the API client
  useEffect(() => {
    setWarmingStateCallback(setIsWarming);
  }, []);

  return (
    <WarmingContext.Provider value={{ isWarming, setIsWarming }}>
      {children}
    </WarmingContext.Provider>
  );
}

export function useWarming() {
  const context = useContext(WarmingContext);
  if (context === undefined) {
    throw new Error("useWarming must be used within a WarmingProvider");
  }
  return context;
}
